import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAlarmExclamation,
  faBan,
  faBell,
  faBriefcase,
  faCalendarDay,
  faCalendarPlus,
  faCalendarTimes,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faClone,
  faCloudDownload,
  faCloudUpload,
  faCommentEdit,
  faCommentExclamation,
  faCommentPlus,
  faComments,
  faCommentTimes,
  faCreditCard,
  faDiceFive,
  faDiceFour,
  faDiceOne,
  faDiceSix,
  faDiceThree,
  faDiceTwo,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faExternalLink,
  faFileEdit,
  faFileInvoice,
  faFilePdf,
  faFilePlus,
  faFileTimes,
  faHeadset,
  faHeadSide,
  faHome,
  faImage,
  faInfo,
  faLayerGroup,
  faLock,
  faMap,
  faMapMarked,
  faMapMarkerAlt,
  faMobile,
  faPaperclip,
  faPaste,
  faPencil,
  faPhone,
  faPlay,
  faPlusCircle,
  faPlusHexagon,
  faReceipt,
  faShareSquare,
  faSignature,
  faSignIn,
  faSignOut,
  faSpinner,
  faStarExclamation,
  faTachometerAlt,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faUndo,
  faUser,
  faUserEdit,
  faUserHardHat,
  faUsersClass,
  faWallet,
  faWrench,
  faCalendarEdit,
  faArrowToLeft,
  faArrowToRight,
  faLayerMinus,
  faLayerPlus,
  faBold,
  faFileInvoiceDollar,
  faMousePointer,
  faSkullCrossbones,
  faCommentAltDollar,
  faMapMarkedAlt,
  faMale,
  faLink,
  faBookOpen,
  faImages,
  faGiftCard,
  faUserCrown,
  faHandHoldingHeart,
  faCalendarStar,
  faCloud,
  faClouds,
  faFog,
  faIcicles,
  faCloudHail,
  faSunHaze,
  faBolt,
  faSunCloud,
  faCloudSun,
  faCloudShowers,
  faSnowflake,
  faSun,
  faWind,
  faLockOpenAlt,
  faLockAlt,
  faEnvelopeOpenDollar,
  faCommentAltExclamation,
  faClipboardCheck,
  faComment,
} from "@fortawesome/pro-light-svg-icons";
import {
  faBadge as faBadgeRegular,
  faBan as faBanRegular,
  faEye as FaEyeRegular,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBadgeCheck as faBadgeCheckSolid,
  faBadge as faBadgeSolid,
  faUsers as faUsersSolid,
  faThumbsUp as faThumbsUpSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faHeadset as faHeadsetSolid,
  faInfoCircle as faInfoCircleSolid,
  faShippingFast as faShippingFastSolid,
  faWrench as faWrenchSolid,
  faStar as faStarSolid,
  faTelescope as faTelescopeSolid,
  faList as faListSolid,
  faMapMarkedAlt as faMapMarkedAltSolid,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faStarHalf as faStarHalfDuotone,
  faSortDown as faSortDownDuotone,
  faHistory as faHistoryDuotone,
  faCalendarDay as fafaCalendarDayDuotone,
  faArchive as faArchiveDuotone,
  faRepeat as faRepeatDuotone,
  faThumbsUp as faThumbsUpDuotone,
} from "@fortawesome/pro-duotone-svg-icons";
import { faTelescope as faTelescopeThin } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faSkullCrossbones,
  faAlarmExclamation,
  faBan,
  faBell,
  faBriefcase,
  faCalendarDay,
  faCalendarPlus,
  faCalendarTimes,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faClone,
  faCloudDownload,
  faCloudUpload,
  faCommentEdit,
  faCommentExclamation,
  faCommentPlus,
  faComments,
  faCommentTimes,
  faCreditCard,
  faDiceFive,
  faDiceFour,
  faDiceOne,
  faDiceSix,
  faDiceThree,
  faDiceTwo,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faExternalLink,
  faFileEdit,
  faFileInvoice,
  faFilePdf,
  faFilePlus,
  faFileTimes,
  faHeadset,
  faHeadSide,
  faHome,
  faImage,
  faInfo,
  faLayerGroup,
  faLock,
  faMap,
  faMapMarked,
  faMapMarkerAlt,
  faMobile,
  faPaperclip,
  faPaste,
  faPencil,
  faPhone,
  faPlay,
  faPlusCircle,
  faPlusHexagon,
  faReceipt,
  faShareSquare,
  faSignature,
  faSignIn,
  faSignOut,
  faSpinner,
  faStarExclamation,
  faTachometerAlt,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faUndo,
  faUser,
  faUserEdit,
  faUserHardHat,
  faUsersClass,
  faWallet,
  faWrench,
  faCalendarEdit,
  faArrowToLeft,
  faArrowToRight,
  faLayerMinus,
  faLayerPlus,
  faBold,
  faFileInvoiceDollar,
  faMousePointer,
  faCommentAltDollar,
  faMapMarkedAlt,
  faMale,
  faLink,
  faBookOpen,
  faImages,
  faGiftCard,
  faUserCrown,
  faHandHoldingHeart,
  faCalendarStar,
  faCloud,
  faClouds,
  faFog,
  faIcicles,
  faCloudHail,
  faSunHaze,
  faBolt,
  faSunCloud,
  faCloudSun,
  faCloudShowers,
  faSnowflake,
  faSun,
  faWind,
  faLockOpenAlt,
  faLockAlt,
  faEnvelopeOpenDollar,
  faCommentAltExclamation,
  faClipboardCheck,
  faComment
);
library.add(faBadgeRegular, faBanRegular, FaEyeRegular);
library.add(
  faBadgeCheckSolid,
  faBadgeSolid,
  faUsersSolid,
  faThumbsUpSolid,
  faExclamationTriangleSolid,
  faHeadsetSolid,
  faInfoCircleSolid,
  faShippingFastSolid,
  faWrenchSolid,
  faStarSolid,
  faTelescopeSolid,
  faListSolid,
  faMapMarkedAltSolid
);
library.add(
  faStarHalfDuotone,
  faSortDownDuotone,
  faHistoryDuotone,
  fafaCalendarDayDuotone,
  faArchiveDuotone,
  faRepeatDuotone,
  faThumbsUpDuotone
);
library.add(faTelescopeThin);

Vue.component("FontAwesomeIcon", FontAwesomeIcon);
